export enum RELATED_PRODUCTS_ACTION {
  ADD = 'add',
  REMOVE = 'remove',
}
